<template>
  <div class="recycling-page">
    <div class="layout-container">
      <div class="left-boxes">
        <div class="time-weather">
          <div class="current-time">{{ currentTime }}</div>
          <div class="weather-info" style="margin-left: 30px">天气：{{ temperatureRange }}</div>
        </div>
        <dv-border-box-8 class="side-box tall-box">
          <div class="box-content info-box">
            <div class="info-header">
              <div class="info-logo">
                <img src="@/assets/logo.png" alt="logo" />
              </div>
              <div class="info-title">
                <div class="main-title">博乐市润景环境卫生管理有限责任公司</div>
                <div class="sub-title">BO LE RUN JING</div>
              </div>
            </div>
            <div class="info-tags scroll-text">
              <span>博乐市润景环境卫生管理有限责任公司成立于2022年。是博尔塔拉蒙古自治州博乐市重点打造的城市公共服务类国有控股企业。注册资本1亿元人民币。</span>
              <span>公司以“建设智慧城市，推动绿色发展”为核心理念。致力于为城市提供全方位、高效率、智能化的环境卫生解决方案。是区域内最具影响力和专业性的现代环卫服务提供商之一。</span>
              <span>公司围绕“智慧化、标准化、可持续”三大核心战略。积极推动城市生活垃圾分类投放、收集、运输、处理等全流程智能化管理。逐步构建起“资源回收—数据监控—终端处理”一体化闭环运营体系。</span>
              <span>在环卫设备投放方面。依托智能垃圾回收箱、分类投放站、称重识别系统等新技术。提升居民参与度与环卫效率。推动无废城市建设取得显著成果。</span>
            </div>
          </div>
        </dv-border-box-8>

        <dv-border-box-8 class="side-box tall-box">
          <div class="box-content">
            <div class="chart-title">各类回收物品总量</div>
            <dv-active-ring-chart :config="ringConfig" style="width:300px; height:300px; margin: 0 auto;" />
          </div>
        </dv-border-box-8>
      </div>

      <div class="center-box">
        <div class="flop-header">
          <div class="flop-card">
            <div class="flop-inner">
              <div class="flop-title">平台总用户数</div>
              <div class="flop-content">
                <dv-digital-flop :config="flopConfigUser" class="flop-number" />
              </div>
            </div>
          </div>

          <div class="flop-card-right">
            <div class="flop-inner">
              <div class="flop-title">平台总投递量</div>
              <div class="flop-content">
                <dv-digital-flop :config="flopConfigMember" class="flop-number" />
              </div>
            </div>
          </div>
        </div>

        <dv-border-box-12 class="map-box">
          <div class="map-inner">
            <div id="baiduMap" class="map-container"></div>
            <div class="map-controls">
              <button @click="setMapType('satellite')">卫星</button>
              <button @click="setMapType('normal')">地图</button>
            </div>
          </div>
        </dv-border-box-12>
      </div>

      <div class="right-boxes">
        <!-- box3 -->
        <dv-border-box-8 class="side-box">
          <div class="box-content">
            <div class="chart-title">{{ currentCommunity }}回收箱总回收量</div>
            <dv-loading v-if="isLoadingTotal" style="width:100%; height:100%; position:absolute;" />
            <dv-capsule-chart v-else :config="capsuleTotalConfig" style="width:100%; height:85%" />
          </div>
        </dv-border-box-8>

        <!-- box4 -->
        <dv-border-box-8 class="side-box">
          <div class="box-content">
            <div class="chart-title">{{ currentCommunity }}回收箱本月回收量</div>
            <dv-loading v-if="isLoadingTotal" style="width:100%; height:100%; position:absolute;" />
            <dv-capsule-chart v-else :config="capsuleMonthConfig" style="width:100%; height:85%" />
          </div>
        </dv-border-box-8>

        <!-- box5 -->
        <dv-border-box-8 class="side-box">
          <div class="box-content">
            <div class="chart-title">{{ currentCommunity }}当天回收箱回收量</div>
            <dv-loading v-if="isLoadingTotal" style="width:100%; height:100%; position:absolute;" />
            <dv-capsule-chart v-else :config="capsuleTodayConfig" style="width:100%; height:85%" />
          </div>
        </dv-border-box-8>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/utils/request' // 或者 './utils/request' 看你路径
/* global BMap */
let map = null;
let satelliteLayer = null;
let labelLayer = null;
let normalMapLayer = null;

export default {
  data() {
    return {
      baseNumberUser: 0,
      baseNumberMember: 0,
      currentTime: '',
      temperatureRange: '',
      isLoadingTotal: false,
      isLoadingMonth: false,
      isLoadingToday: false,
      ringConfig: {
        data: [
          // { name: '废纸', value: 16799999 },
          // { name: '衣物', value: 123 },
          // { name: '塑料', value: 98 },
          // { name: '金属', value: 75 }
        ],
        radius: '60%',
        activeRadius: '70%',
        digitalFlopStyle: {
          fontSize: 20
        },
        color: ['#e062ae', '#fb7293', '#e690d1', '#32c5e9', '#96bfff']
      },
      flopConfigUser: null,
      flopConfigMember: null,
      flopTimer: null,
      capsuleTotalConfig: {
        data: [
          { name: '废纸', value: 320 },
          { name: '衣物', value: 123 },
          { name: '塑料', value: 210 },
          { name: '金属', value: 160 }
        ],
        colors: ['#37a2da', '#32c5e9', '#67e0e3'],
        unit: 'kg',
        showValue: true
      },
      capsuleMonthConfig: {
        data: [
          { name: '废纸', value: 102 },
          { name: '衣物', value: 123 },
          { name: '塑料', value: 88 },
          { name: '金属', value: 66 }
        ],
        colors: ['#ff9f7f', '#fb7293', '#e690d1'],
        unit: 'kg',
        showValue: true
      },
      capsuleTodayConfig: {
        data: [
          { name: '废纸', value: 21 },
          { name: '衣物', value: 123 },
          { name: '塑料', value: 16 },
          { name: '金属', value: 8 }
        ],
        colors: ['#93beff', '#a0cfff', '#c2d6ff'],
        unit: 'kg',
        showValue: true
      },
      currentCommunity: '锦绣小区',
      communityDataMap: {
        '锦绣小区': {
          total: [
            { name: '废纸', value: 21 },
            { name: '衣物', value: 123 },
            { name: '塑料', value: 16 },
            { name: '金属', value: 8 }
          ],
          month: [
            { name: '废纸', value: 21 },
            { name: '衣物', value: 123 },
            { name: '塑料', value: 16 },
            { name: '金属', value: 8 }
          ],
          today: [
            { name: '废纸', value: 21 },
            { name: '衣物', value: 123 },
            { name: '塑料', value: 16 },
            { name: '金属', value: 8 }
          ]
        },
        '州技校1号': {
          total: [
            { name: '废纸', value: 4444 },
            { name: '衣物', value: 3333 },
            { name: '塑料', value: 2222 },
            { name: '金属', value: 1111 }
          ],
          month: [
            { name: '废纸', value: 444 },
            { name: '衣物', value: 333 },
            { name: '塑料', value: 222 },
            { name: '金属', value: 111 }
          ],
          today: [
            { name: '废纸', value: 44 },
            { name: '衣物', value: 33 },
            { name: '塑料', value: 22 },
            { name: '金属', value: 11 }
          ]
        },
        '祥嘉苑·幸福里': {
          total: [
            { name: '废纸', value: 9999 },
            { name: '衣物', value: 8888 },
            { name: '塑料', value: 7777 },
            { name: '金属', value: 6666 }
          ],
          month: [
            { name: '废纸', value: 999 },
            { name: '衣物', value: 888 },
            { name: '塑料', value: 777 },
            { name: '金属', value: 666 }
          ],
          today: [
            { name: '废纸', value: 99 },
            { name: '衣物', value: 88 },
            { name: '塑料', value: 77 },
            { name: '金属', value: 66 }
          ]
        },
        '南湖新苑': {
          total: [
            { name: '废纸', value: 6666 },
            { name: '衣物', value: 5555 },
            { name: '塑料', value: 4444 },
            { name: '金属', value: 3333 }
          ],
          month: [
            { name: '废纸', value: 666 },
            { name: '衣物', value: 555 },
            { name: '塑料', value: 444 },
            { name: '金属', value: 333 }
          ],
          today: [
            { name: '废纸', value: 66 },
            { name: '衣物', value: 55 },
            { name: '塑料', value: 44 },
            { name: '金属', value: 33 }
          ]
        }
        // 你可以继续添加其他小区
      },
      // capsuleTotalConfig: {},
      // capsuleMonthConfig: {},
      // capsuleTodayConfig: {},
    };
  },
  mounted() {
    this.initMap();
    this.updateFlop();
    this.fetchWeather();
    // this.flopTimer = setInterval(() => {
    //   this.baseNumberUser += 3;
    //   this.baseNumberMember += 2;
    //   this.updateFlop();
    // }, 5000);
    this.updateTime();
    setInterval(this.updateTime, 1000);
    this.handleDeviceClick('FYHSX040A2403137', '锦绣B区');
    this.setCurrentCommunity(this.currentCommunity);
    this.getTotal();//获取总人数
    this.getTotal_weight();//获取总回收量
    // this.getType_weight();//获取各类垃圾总量
    setTimeout(() => {
      this.getType_weight();
    }, 500);
  },
  beforeDestroy() {
    clearInterval(this.flopTimer);
  },
  methods: {
    getTotal() {
      request({
        url: '/user/total',   // 请求地址
        method: 'get',           // 请求方式
        // params: { userId: 123 }  // GET 请求参数
      }).then(res => {
        let tot = Number(res.data.data.total)
        console.log('tot::: ', tot);
        this.updateFlop('N', tot)
        // this.flopConfigUser = {
        //   number: [tot],
        //   content: '{nt}人',
        //   // formatter: formatNumber
        // };
        console.log('返回结果:', res)
      }).catch(err => {
        console.error('请求失败:', err)
      })
    },
    getTotal_weight() {
      request({
        url: '/order/total_weight',   // 请求地址
        method: 'get',           // 请求方式
        // params: { userId: 123 }  // GET 请求参数
      }).then(res => {

        let tot = Number(res.data.data.total_weight)
        this.updateFlop('Y', tot)
        console.log('tot::: ', tot);
        // this.flopConfigMember = {
        //   number: [tot],
        //   content: '{nt}KG',
        //   // formatter: formatNumber
        // };
        console.log('返回结果:', res)
      }).catch(err => {
        console.error('请求失败:', err)
      })
    },
    getType_weight() {
      request({
        url: '/order/type_weight',   // 请求地址
        method: 'get',           // 请求方式
      }).then(res => {
        console.log('res::: ', res);
        const result = this.formatToPercentage(res.data.data)
        console.log('result::: ', result);
        // this.ringConfig.data = result;
        this.ringConfig = {
          ...this.ringConfig,
          data: result
        };
        console.log('this.ringConfig::: ', this.ringConfig);
      }).catch(err => {
        console.error('请求失败:', err)
      })
    },
    formatToPercentage(data) {
      // const total = Object.values(data).reduce((sum, val) => sum + val, 0);

      const result = Object.entries(data).map(([key, value]) => {
        // const percent = ((value / total) * 100).toFixed(2);
        return {
          name: key,
          value: Number(value.toFixed(0)),  // 保留两位小数并转为数字
          // percent: percent + '%'
        };
      });

      console.log('result::: ', result);

      return result;
    },
    updateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hour = String(now.getHours()).padStart(2, '0');
      const minute = String(now.getMinutes()).padStart(2, '0');
      const second = String(now.getSeconds()).padStart(2, '0');
      this.currentTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    updateFlop(y, baseNumberUser) {
      const formatNumber = number => {
        const nums = number.toString().split('').reverse();
        const segs = [];
        while (nums.length) segs.push(nums.splice(0, 3).join(''));
        return segs.join(',').split('').reverse().join('');
      };
      this.baseNumberUser = baseNumberUser
      if (y === 'Y') {
        this.flopConfigMember = {
          number: [this.baseNumberUser],
          content: '{nt}KG',
          formatter: formatNumber
        }
      }
      if (y === 'N') {
        this.flopConfigUser = {
          number: [this.baseNumberUser],
          content: '{nt}人',
          formatter: formatNumber
        };
      }


    },
    initMap() {
      map = new BMap.Map("baiduMap");
      const centerPoint = new BMap.Point(82.05957, 44.85455);
      map.centerAndZoom(centerPoint, 13);
      map.enableScrollWheelZoom(true);

      satelliteLayer = new BMap.TileLayer();
      satelliteLayer.getTilesUrl = (tileCoord, zoom) =>
        `http://shangetu${(tileCoord.x + tileCoord.y) % 4}.map.bdimg.com/it/u=x=${tileCoord.x};y=${tileCoord.y};z=${zoom};v=009;type=sate&fm=46`;

      labelLayer = new BMap.TileLayer();
      labelLayer.getTilesUrl = (tileCoord, zoom) =>
        `http://online${(tileCoord.x + tileCoord.y) % 4}.map.bdimg.com/tile/?qt=tile&x=${tileCoord.x}&y=${tileCoord.y}&z=${zoom}&styles=sl`;

      normalMapLayer = new BMap.TileLayer();
      normalMapLayer.getTilesUrl = (tileCoord, zoom) =>
        `http://online${(tileCoord.x + tileCoord.y) % 4}.map.bdimg.com/tile/?qt=tile&x=${tileCoord.x}&y=${tileCoord.y}&z=${zoom}&styles=pl`;

      map.addTileLayer(satelliteLayer);
      map.addTileLayer(labelLayer);

      // 🔥 请求真实接口获取地图点数据
      request({
        url: 'https://anjat.bolerunjing.cn/An74/api/order/weight_by_device',
        method: 'get'
      }).then(res => {
        const points = res.data.data || []; // 根据你的接口结构调整路径

        points.forEach((p) => {
          const point = new BMap.Point(p.lon, p.lat);
          const marker = new BMap.Marker(point);

          // const label = new BMap.Label(
          //   `${p.device_name}<br/>设备编号：${p.device_code}`, {
          //   offset: new BMap.Size(20, -10)
          // });

          const label = new BMap.Label(
            `${p.device_name}<br/>总回收量：${p.total_weight} kg`, {
            offset: new BMap.Size(20, -10)
          });

          label.setStyle({
            backgroundColor: "#fff",
            border: "1px solid red",
            fontSize: "14px",
            color: "red",
            padding: "4px",
            whiteSpace: "nowrap",
            cursor: "pointer"
          });

          marker.setLabel(label);
          map.addOverlay(marker);

          marker.addEventListener('click', () => {
            this.handleDeviceClick(p.device_code, p.device_name);  // 带设备编号 + 名称
          });

          label.addEventListener('click', () => {
            this.handleDeviceClick(p.device_code, p.device_name);
          });
        });
      }).catch(err => {
        console.error('地图点加载失败:', err);
      });
    },
    handleDeviceClick(deviceCode, deviceName) {
      this.currentCommunity = deviceName;
      this.isLoadingTotal = true;
      this.isLoadingMonth = true;
      this.isLoadingToday = true;

      request({
        url: 'https://anjat.bolerunjing.cn/An74/api/order/weight_by_type',
        method: 'get',
        params: { device_code: deviceCode }
      })
        .then(res => {
          const rawData = res.data?.data || {};

          this.capsuleTotalConfig = {
            data: this.formatToChartData(rawData['总量']),
            colors: ['#37a2da', '#32c5e9', '#67e0e3'],
            unit: 'kg',
            showValue: true
          };
          this.capsuleMonthConfig = {
            data: this.formatToChartData(rawData['本月']),
            colors: ['#ff9f7f', '#fb7293', '#e690d1'],
            unit: 'kg',
            showValue: true
          };
          this.capsuleTodayConfig = {
            data: this.formatToChartData(rawData['昨日']),  // 实际是昨日
            colors: ['#93beff', '#a0cfff', '#c2d6ff'],
            unit: 'kg',
            showValue: true
          };
        })
        .catch(err => {
          console.error('获取设备回收量失败:', err);
        })
        .finally(() => {
          this.isLoadingTotal = false;
          this.isLoadingMonth = false;
          this.isLoadingToday = false;
        });
    },
    formatToChartData(obj) {
      if (!obj || typeof obj !== 'object') return [];

      return Object.entries(obj).map(([key, val]) => ({
        name: key,
        value: Number(val.toFixed(2))  // 保留两位小数
      }));
    },
    setMapType(type) {
      if (!map) return;
      if (satelliteLayer) map.removeTileLayer(satelliteLayer);
      if (labelLayer) map.removeTileLayer(labelLayer);
      if (normalMapLayer) map.removeTileLayer(normalMapLayer);

      if (type === "satellite") {
        map.addTileLayer(satelliteLayer);
        map.addTileLayer(labelLayer);
      } else if (type === "normal") {
        map.addTileLayer(normalMapLayer);
      }
    },
    async fetchWeather() {
      try {
        const res = await fetch('https://api.open-meteo.com/v1/cma?latitude=44.905&longitude=82.066&daily=temperature_2m_max,temperature_2m_min,precipitation_sum&timezone=Asia/Shanghai');
        const data = await res.json();
        const min = data.daily.temperature_2m_min[0];
        const max = data.daily.temperature_2m_max[0];
        this.temperatureRange = `${min}~${max}℃`;
      } catch (error) {
        console.error('天气获取失败', error);
        this.temperatureRange = '获取失败';
      }
    },
    setCurrentCommunity(name) {
      if (!this.communityDataMap[name]) {
        console.warn('该小区没有数据：', name);
        return;
      }

      this.currentCommunity = name;

      const data = this.communityDataMap[name];

      this.capsuleTotalConfig = {
        data: data.total || [],
        colors: ['#37a2da', '#32c5e9', '#67e0e3'],
        unit: 'kg',
        showValue: true
      };
      this.capsuleMonthConfig = {
        data: data.month || [],
        colors: ['#ff9f7f', '#fb7293', '#e690d1'],
        unit: 'kg',
        showValue: true
      };
      this.capsuleTodayConfig = {
        data: data.today || [],
        colors: ['#93beff', '#a0cfff', '#c2d6ff'],
        unit: 'kg',
        showValue: true
      };
    }

  }
}; 
</script>

<style scoped>
.recycling-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 15px;
  min-height: 100vh;
  background: url('@/assets/map-bg.jpg') no-repeat center center;
  background-size: cover;
}

.flop-header {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 20px;
}

.flop-card,
.flop-card-right {
  width: auto;          /* 你可以调整为适配内容大小 */
  height: auto;
  background: none;     /* 👈 不要背景 */
  box-shadow: none;     /* 👈 去掉阴影 */
  border-radius: 0;     /* 👈 去掉圆角 */
  display: flex;
  align-items: center;
  justify-content: center;
}

.flop-inner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px;
  box-sizing: border-box;
}

.flop-title {
  font-size: 20px;
  font-weight: bold;
  color: #ffffff; /* 👈 白色文字 */
  margin-bottom: 5px;
}

.flop-number {
  font-size: 36px !important;
  color: #00ffaa;
  font-weight: bold;
  text-align: center;
}


.flop-content {
  height: 60px;
  /* 👈 明确翻牌数字区域的高度 */
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 5px;
  /* 👈 控制翻牌数字垂直位置 */
  box-sizing: border-box;
}



.flop-label {
  font-size: 16px;
  color: #ffffff;
  margin-bottom: 8px;
  font-weight: 500;
}


.flop-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}


.layout-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 30px;
}

.right-boxes {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.left-boxes {
  display: flex;
  flex-direction: column;
  gap: 35px;
  /* 原来是 20px */
}

.side-box {
  width: 520px;
  height: 280px;
  /* 从360px调为280px */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 12px;
}

.box-content {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.2);
  color: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}

.map-box {
  width: 80vh;
  height: 80vh;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.map-inner {
  position: relative;
  width: 100%;
  height: 100%;
}

.map-container {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.map-controls {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10;
}

.map-controls button {
  margin-left: 8px;
  padding: 5px 12px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}

.map-controls button:hover {
  background-color: #1e90ff;
}

.info-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 15px;
  color: #fff;
}

.info-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.info-logo img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.info-title .main-title {
  font-size: 20px;
  font-weight: bold;
}

.info-title .sub-title {
  font-size: 14px;
  color: #9fcfff;
}

.info-tags {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  color: #fff;
}

.scroll-text span {
  text-indent: 2em;
  margin-bottom: 1em;
}

.time-weather {
  font-size: 18px;
  color: #fff;
  text-align: left;
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 10px;
  margin-bottom: 15px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
}

.current-time {
  font-weight: bold;
}

.weather-info {
  margin-left: 30px;
}

.tall-box {
  height: 380px;
}

.chart-title {
  font-size: 16px;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 10px;
  text-align: center;
}

dv-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
}
</style>
